import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import ComponentReview from '../../../shared/component-review';
import { BackArrow } from '../../../shared/svgIcons.jsx';
import { submitForm, decrementStep, setStep } from '../../redux/actions';

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const IntroMessage = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #333333;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  // text-transform: uppercase;
  width: 100%;
  margin-top: 1.5rem;
  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const InfoHeader = styled.div`
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  text-transform: uppercase;
  padding-bottom: 1rem;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  p {
    font-family: 'OCRoboto';
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #333333;
    margin-top: 0;
  }

  h3 {
    font-family: 'OCRoboto';
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: #333333;
    padding-right: 1.5rem;
    text-transform: none;
  }

  div {
    display: flex;
  }

  span {
    font-family: 'OCRoboto';
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-decoration-line: underline;
    color: #000000;
    text-transform: uppercase;
    cursor: pointer;
  }
`;

const mapStateToProps = state => ({
  formData: state.formData,
  appData: state.appData,
  disableSubmitBtn: state.disableSubmitBtn,
});

const Installer = ({ formData, setStep }) => {
  const { installingContractorData, installingContractor } = formData;

  let contractorName = installingContractor;
  if (installingContractorData && installingContractorData.company_name) {
    contractorName = installingContractorData.company_name;
  }

  return (
    <InfoWrapper>
      <div>
        <h3>Installer</h3>
        <span
          data-track="form-edit"
          data-track-form-name="Warranty Registration"
          data-track-form-step="step 16 - does this look right to you"
          onClick={() => setStep(9)}
        >
          Edit
        </span>
      </div>
      <p>{contractorName || 'None'}</p>
    </InfoWrapper>
  );
};

const HomeownerStep15 = ({ submitForm, decrementStep, setStep, formData, appData, disableSubmitBtn }) => {
  const shingleData = appData.shingleData || {};
  const shingleLines = shingleData.products || [];
  const shingleLine = shingleLines.find(line => line.uid == formData.shingleLine) || {};

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 16 - does this look right to you"
        onClick={decrementStep}
      >
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>Please read and accept our terms of service.</BackText>
      </BackWrapper>
      <IntroMessage>Now that we have all of that…</IntroMessage>
      <Header>Does this look right to you?</Header>
      <InfoHeader>Your Info</InfoHeader>
      <InfoWrapper>
        <div>
          <h3>Roof Address</h3>
          <span
            data-track="form-edit"
            data-track-form-name="Warranty Registration"
            data-track-form-step="step 16 - does this look right to you"
            onClick={() => setStep(5)}
          >
            Edit
          </span>
        </div>
        <p>
          {formData.propertyAddress.street} {formData.propertyAddress.streetLine2}, {formData.propertyAddress.city},{' '}
          {formData.propertyAddress.state}, {formData.propertyAddress.zip}
        </p>
      </InfoWrapper>
      <Installer formData={formData} setStep={setStep} />
      <InfoWrapper>
        <div>
          <h3>Installation Date</h3>
          <span
            data-track="form-edit"
            data-track-form-name="Warranty Registration"
            data-track-form-step="step 16 - does this look right to you"
            onClick={() => setStep(7)}
          >
            Edit
          </span>
        </div>
        <p>
          {formData.installDateMonth}/{formData.installDateDay}/{formData.installDateYear}
        </p>
      </InfoWrapper>
      <InfoWrapper>
        <div>
          <h3>Shingles Installed</h3>
          <span
            data-track="form-edit"
            data-track-form-name="Warranty Registration"
            data-track-form-step="step 16 - does this look right to you"
            onClick={() => setStep(11)}
          >
            Edit
          </span>
        </div>
        <p>
          {shingleLine.product_legal_name} - {formData.shingleColor}
        </p>
      </InfoWrapper>
      <InfoWrapper>
        <div>
          <h3>Roof Size</h3>
          <span
            data-track="form-edit"
            data-track-form-name="Warranty Registration"
            data-track-form-step="step 16 - does this look right to you"
            onClick={() => setStep(8)}
          >
            Edit
          </span>
        </div>
        <p>{formData.squares}</p>
      </InfoWrapper>
      <InfoWrapper>
        <div>
          <h3>OC Roofing Components Installed</h3>
          <span
            data-track="form-edit"
            data-track-form-name="Warranty Registration"
            data-track-form-step="step 16 - does this look right to you"
            onClick={() => setStep(12)}
          >
            Edit
          </span>
        </div>
        <ComponentReview />
      </InfoWrapper>
      <InfoHeader>Warranty Details</InfoHeader>
      <InfoWrapper>
        <h3>Warranty</h3>
        <p>Total Protection Roofing System Limited Warranty</p>
      </InfoWrapper>
      <InfoWrapper>
        <h3>Overall Warranty Length</h3>
        <p>Lifetime*</p>
      </InfoWrapper>
      <InfoWrapper>
        <h3>Products Included</h3>
        <p>All Owens Corning® Components & Shingles</p>
      </InfoWrapper>
      <NextButton
        data-track="form-submit"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 16 - does this look right to you"
        disabled={disableSubmitBtn}
        onClick={submitForm}
      >
        {disableSubmitBtn ? 'Submitting...' : 'Looks Good!'}
      </NextButton>
      <BackText>* Lifetime coverage means that your warranty is in effect as long as you own your property.</BackText>
    </StepWrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  submitForm: () => dispatch(submitForm()),
  decrementStep: () => dispatch(decrementStep()),
  setStep: step => dispatch(setStep(step)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeownerStep15);
